const UPLOAD_FOLDER_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/uploads/`;

const stables = { UPLOAD_FOLDER_BASE_URL };

export default stables;
